import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * その他
 */
const OthersIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-16 -528.5)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(16 528.5)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <path
            d="M14.414,19.931h2.759V22.69H14.414Zm0-11.034h2.759v8.276H14.414ZM15.779,2A13.793,13.793,0,1,0,29.586,15.793,13.786,13.786,0,0,0,15.779,2Zm.014,24.828A11.034,11.034,0,1,1,26.828,15.793,11.031,11.031,0,0,1,15.793,26.828Z"
            transform="translate(19.897 532.517)"
            fill={CLIENT_SETTINGS.colors.main}
          />
        </g>
      </svg>
    </Icon>
  )
}

export default OthersIcon
